import { useEffect, useRef, useCallback } from 'react';
import successfulClickSound from '../assets/audio/CorrectClick.mp3';
import unsuccessfulClickSound from '../assets/audio/IncorrectClick.mp3';
import chopSound from '../assets/audio/VeggieCut.mp3';
import timerTick from '../assets/audio/CookingTick2.mp3';
import winSound from '../assets/audio/VictorySound.mp3';
import failureSound from '../assets/audio/FailureSound.mp3';
import cookwareFull from '../assets/audio/CookwareFull.mp3';
import cookDone from '../assets/audio/CookDone.mp3';
import countDown from '../assets/audio/CountDown.mp3';
import { useAppContext } from '../context/AppContext';

const useAudioManager = () => {
  const audioRefs = useRef({});
  const { isSoundOn } = useAppContext()

  useEffect(() => {
    const audioFiles = { //add any audio files here
      successfulClick: successfulClickSound,
      unsuccessfulClick: unsuccessfulClickSound,
      chopSound: chopSound,
      timerTick: timerTick,
      winSound: winSound,
      failureSound: failureSound,
      cookDone: cookDone,
      countDown: countDown,
      cookwareFull: cookwareFull
    };

    Object.entries(audioFiles).forEach(([key, src]) => {
      const audio = new Audio(src);
      audio.preload = 'auto';
      audioRefs.current[key] = audio;
    });

    return () => {
      Object.values(audioRefs.current).forEach(audio => audio.pause());
    };
  }, []);

  useEffect(() => {
    if (!audioRefs || !audioRefs.current) {
      return
    }
    console.log(audioRefs.current)

    const keys = Object.keys(audioRefs.current)

    if (isSoundOn) {
      keys.forEach((key) => {
        const audio = audioRefs.current[key]
        audio.muted = false
      })
    } else {
      keys.forEach((key) => {
        const audio = audioRefs.current[key]
        audio.muted = true
      })
    }
  }, [isSoundOn, audioRefs]);

  const playSound = useCallback((soundName) => {
    const audio = audioRefs.current[soundName];
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch(error => console.error('sound error', error));
    } 
}, []);

  const stopSound = useCallback((soundName) => {
    console.log(`Attempting to stop sound: ${soundName}`);
    const audio = audioRefs.current[soundName];
    if (audio) {
      audio.pause();
      audio.currentTime = 0; // Reset to start
    }
  }, []);

  return { playSound, stopSound };
};

export default useAudioManager;